import { Component, effect, inject, OnDestroy, signal } from '@angular/core';
import { FormField, form } from '@angular/forms/signals';
import { debounceTime, distinctUntilChanged, firstValueFrom, map, skipWhile, Subject, Subscription } from 'rxjs';
import { GetStreamService } from '../../services/get-stream/get-stream.service';
import { AsyncPipe } from '@angular/common';
import { LoadingInlineComponent } from '../../atoms/loading-inline/loading-inline.component';
import { ChannelInfoDrawerComponent } from '../../atoms/channel-info-drawer/channel-info-drawer.component';
import { StreamChatModule, StreamTextareaModule } from 'stream-chat-angular';
import { Router } from '@angular/router';
import { CreatorProfileComponent } from '../creators/molecules/creator-profile/creator-profile.component';
import { MagicSearchService } from '../creators/service/magic-search/magic-search.service';
import { CreatorService } from '../../services/creator/creator.service';
import { CreatorResponseDto } from '../../common/general-types/creators.dto';



@Component({
  selector: 'app-inbox-full',
  standalone: true,
  imports: [FormField, AsyncPipe, LoadingInlineComponent, StreamChatModule,
    StreamTextareaModule, CreatorProfileComponent, ChannelInfoDrawerComponent
  ],
  templateUrl: './inbox-full.component.html',
  styleUrl: './inbox-full.component.css'
})
export class InboxFullComponent implements OnDestroy {

  private subscriptions = new Subscription();

  /** Search Inbox */
  private inboxSearchQuerySubject = new Subject<string>();
  inboxSearchQueryModel = signal({
    query: '',
  })
  inboxSearchQueryForm = form(this.inboxSearchQueryModel)
  /** Search Inbox - END */

  allowedActions = ['react', 'quote-reply', 'copy', 'mark-unread'];

  /** Services */
  private router = inject(Router);
  public getStreamService = inject(GetStreamService);
  public magicSearchService = inject(MagicSearchService);
  private creatorService = inject(CreatorService);
  /** Services - END */


  constructor() {
    this.subscriptions.add(
      this.inboxSearchQuerySubject.pipe(
        debounceTime(350),
        map((query) => query.trim()),
        distinctUntilChanged(),
        // The empty query is emitted when the page opens. Chat is already connected
        // from login — reloading it flashes the loading state over the inbox.
        skipWhile((query) => query.length === 0),
      ).subscribe((query) => {
        if (query.length > 0) {
          void this.getStreamService.reloadStreamChat('query', query);
        } else {
          void this.getStreamService.reloadStreamChat('all');
        }
      }),
    );

    effect(() => {
      const query = this.inboxSearchQueryModel().query;
      this.inboxSearchQuerySubject.next(query);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.getStreamService.deselectActiveChannel();
  }

  canShowContentButton() {
    const activeChannel: any = this.getStreamService.getActiveChannel()!;

    if (activeChannel) {
      const custom_data = activeChannel.data.custom;
      if (custom_data && custom_data.creatorId) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  async viewCreatorProfile() {
    console.log('viewCreatorProfile()');
    if (this.getStreamService.hasActiveChannel()) {
      const activeChannel: any = this.getStreamService.getActiveChannel();
      console.log('activeChannel: ', activeChannel);

      const custom_data = activeChannel.data.custom;

      if (custom_data && custom_data.creatorId) {
        const creator: CreatorResponseDto = await firstValueFrom(this.creatorService.getCreatorById(custom_data.creatorId));
        if (creator) {
          this.magicSearchService.portfolioCreator.set(creator);
          this.magicSearchService.portfolioCreatorId.set(creator.blazeFirebaseUid);
        }
      }
    }
  }

  async viewSubmission() {
    if (this.getStreamService.hasActiveChannel()) {
      const activeChannel: any = this.getStreamService.getActiveChannel();
      console.log('activeChannel: ', activeChannel);

      const custom_data = activeChannel.data.custom;
      const briefId = custom_data.briefId;
      const creatorId = custom_data.creatorId;

      console.log('briefId: ', briefId);
      console.log('creatorId: ', creatorId);

      if (creatorId && briefId) {
        this.router.navigate(['/view-submission', briefId, creatorId]);
      }
    }
  }

  async goToBrief() {
    console.log('goToBrief()');
    if (this.getStreamService.hasActiveChannel()) {
      const activeChannel: any = this.getStreamService.getActiveChannel();
      console.log('activeChannel: ', activeChannel);

      const custom_data = activeChannel.data.custom;
      const briefId = custom_data.briefId;
      const creatorId = custom_data.creatorId;

      console.log('briefId: ', briefId);
      console.log('creatorId: ', creatorId);

      if (creatorId && briefId) {
        this.router.navigate(['/manage-brief', briefId, 1]);
      }
    }
  }
}
